import { colors } from './colors';
import { typography } from './typography';
import { 
  spacing, 
  shadows, 
  breakpoints, 
  transitions, 
  images 
} from './variables';

const theme = {
  colors,
  typography,
  spacing,
  shadows,
  breakpoints,
  transitions,
  images
};

export {
  colors,
  typography,
  spacing,
  shadows,
  breakpoints,
  transitions,
  images
};

export default theme; 